<p-table
  [value]="uploadedFiles"
  responsiveLayout="scroll"
  [columns]="cols"
  dataKey="documentFileName"
  data-test-id="selected-documents-table"
  >
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th
          [ngStyle]="{ width: col.width }"
          >
          {{ col.header }}
        </th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-file let-index="rowIndex" let-expanded="expanded">
    <tr>
      @if (hasExpandableRows) {
        <td>
          @if (canExpandRow(file)) {
            <button
              pButton
              type="button"
              class="p-button-text p-button-rounded"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              [pRowToggler]="file"
            ></button>
          }
        </td>
      }
      <td>
        <span
          class="p-text-break-spaces break-all"
          [pTooltip]="file.documentFileName"
          tooltipStyleClass="tooltip-xl-size"
          tooltipPosition="bottom"
          class="truncate"
        >
          {{ file.documentFileName }}
        </span>
      </td>
      <td>
        {{ file.documentSource }}
      </td>
      <td>
        <span
          class="truncate"
          [pTooltip]="file.documentTypes && file.documentTypes.join(', ')"
          tooltipStyleClass="tooltip-xl-size"
          tooltipPosition="bottom"
        >
          {{ file.documentTypes && file.documentTypes.join(', ') }}
        </span>
      </td>
      <td>
        <span
          [pTooltip]="file.description"
          tooltipPosition="bottom"
          class="truncate"
        >
          {{ file.description }}
        </span>
      </td>
      <td>
        @if (file.documentSource === DocumentSourceType.EHR) {
          --
        } @else {
          {{ file.fileMetaData.size }} Bytes
        }
      </td>
      @if (!viewMode) {
        <td>
          @if (file.documentSource !== DocumentSourceType.EHR) {
            <div class="flex justify-center">
              <button
                pButton
                class="p-button-text"
                type="button"
                label="Remove"
                icon="pi pi-trash"
                data-test-id="remove-document-button"
                (click)="onDeleteItem(index)"
              ></button>
            </div>
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="expandedrow" let-file>
    @if (canExpandRow(file)) {
      <tr>
        <td [attr.colspan]="cols.length">
          <div class="field mb-0 py-3">
            <label class="mb-2">Summary:</label>
            <p class="text-wrap">{{ file.summary }}</p>
          </div>
        </td>
      </tr>
    }
  </ng-template>

</p-table>
